import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Row,
  Col,
  Input,
  notification,
  Modal,
  Popover,
} from "antd";
import { Link, useHistory } from "react-router-dom";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import LoginPic from "../assets/images/OctetLogoBlack.png";
import Screen from "../util/Extensions/Screens";
import { useSelector } from "react-redux";
import RequestHandler from "../util/RequestHandler";

const SignIn = (props) => {
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [visible, setVisible] = useState(false);
  const [mailLogin, setMailLogin] = useState("");
  const [psr, setPsr] = useState("");
  const [smsPsrInput, setSmsPsrInput] = useState("");
  const { initialMinute = 0 } = props;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(180);
  const [errorText, setErrorText] = useState("");
  const [securityImage, setSecurityImage] = useState({
    isUrl: false,
    src: null,
  });
  const [securityImageModal, setSecurityImageModal] = useState({
    visible: false,
    images: [],
  });

  const history = useHistory();

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          handleCancel();
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  useEffect(() => {
    const params = new URLSearchParams(window ? window.location.search : {});
    const codeFromQuery = params.get("code");
    if (codeFromQuery) {
      notification.error({
        message: params.get("message"),
        duration: 5,
      });
      history.replace("/signin");
    }
  }, []);

  const [form] = Form.useForm();

  const showModal = () => {
    setSeconds(180);
    setSmsPsrInput("");
    setErrorText("");
    setVisible(true);
  };

  const handleSubmit = (values) => {
    RequestHandler.post(
      `/Auth/Login`,
      {
        email: mailLogin,
        password: psr,
        screenOption: Screen.screen,
        securityKey: values.Sms,
        securityImage: securityImage.isUrl ? securityImage.src : undefined,
      },
      false
    ).then((response) => {
      if (response.success) {
        setLoading(false);
        RequestHandler.setUserInfo(response);
        window.location.reload();
      } else {
        setLoading(false);
        setLoadingBtn(false);
      }
    });
  };

  const handleCancel = () => {
    if (handleCancel) {
      setLoading(false);
    }
    setVisible(false);
    setLoadingBtn(false);
  };

  const token = useSelector(({ auth }) => auth.token);
  const onFinishFailed = () => setLoading(false);

  const onFinish = (values) => {
    const requestBody = {
      email: values.credentialU,
      password: values.credentialP,
      screenOption: Screen.screen,
    };

    RequestHandler.post(`/Auth/Login`, requestBody, false).then((response) => {
      if (response.success) {
        if (response.data === null) {
          RequestHandler.post(`/Auth/UserSecurityImage`, requestBody, false, {
            rawResponse: true,
            ignoreErrorNotification: true,
          }).then((res) => {
            setMailLogin(values.credentialU);
            setPsr(values.credentialP);

            if (res.status === 200) {
              //image varsa otp adımına geçiyoruz
              setSecurityImage({ isUrl: false, src: res.data });
              showModal();
            } else {
              //image yoksa image seçtirip otp adımına geçiyoruz
              RequestHandler.get(`/Auth/SecurityImages`).then((r) => {
                if (r.success) {
                  setSecurityImage({ isUrl: true, src: null });
                  setSecurityImageModal({ visible: true, images: r.data });
                }
              });
            }
          });
        } else {
          RequestHandler.setUserInfo(response);
          openNotificationWithIcon("success");
          window.location.reload();
        }
      } else {
        setLoading(false);
      }
    });
  };

  const onChangePsrLoginValue = (e) => {
    setErrorText("");
    setSmsPsrInput(e.target.value);
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Giriş işlemi başarılı.",
      duration: 2,
    });
  };

  const ref = useRef();
  useEffect(() => {
    if (token !== null) {
      props.history.push("/home");
    }
  }, [token, props.history]);

  return (
    <div className="gx-login-container">
      <div className="gx-login-content">
        <div className="gx-login-header gx-text-center">
          <h1 className="gx-login-title">
            <img src={LoginPic} alt="Octet" style={{ width: "64%" }} />
          </h1>
        </div>
        <Form
          initialValues={{ remember: true }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0"
          autoComplete="off"
        >
          <Form.Item
            name="credentialU"
            rules={[{ required: true, message: "Email alanı zorunludur!" }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Email"
              autoComplete="off"
            />
          </Form.Item>

          <Form.Item
            name="credentialP"
            rules={[{ required: true, message: "Şifre alanı zorunludur!" }]}
          >
            <Input
              prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Şifre"
              autoComplete="off"
              className="gx-input-password"
            />
          </Form.Item>

          <Link className="gx-login-form-forgot" to="/forget-password">
            Şifremi Unuttum
          </Link>
          <Form.Item className="gx-text-center">
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Giriş Yap
            </Button>
          </Form.Item>
        </Form>
      </div>

      <Modal
        maskClosable={false}
        visible={securityImageModal.visible}
        onOk={() => {
          setSecurityImageModal({ ...securityImageModal, visible: false });
          showModal();
        }}
        okText="Belirle ve Giriş Yap"
        okButtonProps={{
          disabled: !(securityImage.isUrl && securityImage.src),
        }}
        keyboard={false}
        cancelButtonProps={{ hidden: true }}
        onCancel={() => {
          setSecurityImage({ ...securityImage, src: null });
          setSecurityImageModal({ ...securityImageModal, visible: false });
        }}
        destroyOnClose={true}
      >
        <p style={{ marginTop: 10, textAlign: "center", fontSize: 16 }}>
          Lütfen daha sonraki girişlerinizde görüntüleyeceğiniz güvenlik resmini
          belirleyin.
        </p>
        <Row justify="center">
          <Col style={{ width: 300 }}>
            <Row gutter={5}>
              {securityImageModal.images.map((imgSrc) => (
                <Col key={imgSrc} span={8} style={{ margin: "2.5px 0" }}>
                  <a
                    onClick={() =>
                      setSecurityImage({ isUrl: true, src: imgSrc })
                    }
                  >
                    <img
                      src={`${RequestHandler.getApiUrl()}/Auth/SecurityImages/${imgSrc}`}
                      alt=""
                      style={
                        securityImage.src === imgSrc
                          ? {
                              width: 100,
                              opacity: 0.6,
                              border: "2px solid",
                            }
                          : {
                              width: 100,
                            }
                      }
                    />
                  </a>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
        <p style={{ color: "darkred", textAlign: "center", fontWeight: 600 }}>
          {errorText}
        </p>
      </Modal>

      <Modal
        maskClosable={false}
        visible={visible}
        onOk={() => {
          setLoadingBtn(true);
          form.submit();
        }}
        okText="Onayla"
        okButtonProps={{ loading: loadingBtn }}
        keyboard={false}
        cancelButtonProps={{ hidden: true }}
        onCancel={handleCancel}
      >
        <Row justify="center">
          {securityImage.src && (
            <Popover content="Güvenlik resminin size ait olmadığı düşünüyorsanız 0 850 360 1511 numarası üzerinden Octet destek hattıyla iletişime geçebilirsiniz.">
              <img
                src={
                  securityImage.isUrl
                    ? `${RequestHandler.getApiUrl()}/Auth/SecurityImages/${
                        securityImage.src
                      }`
                    : `data:image/jpeg;base64,${securityImage.src}`
                }
                alt=""
                style={{ width: 100 }}
              />
            </Popover>
          )}
        </Row>

        <p style={{ marginTop: 10, textAlign: "center", fontSize: 16 }}>
          {" "}
          Lütfen telefonunuza gelen tek kullanımlık şifreyi <b>
            {seconds}
          </b>{" "}
          saniye içinde girin;{" "}
        </p>

        <Form
          onFinish={handleSubmit}
          fields={[{ name: "Sms", value: smsPsrInput }]}
          ref={ref}
          form={form}
        >
          <Form.Item name="Sms">
            <Input
              onChange={onChangePsrLoginValue}
              type="text"
              maxLength={6}
              autoComplete="off"
              style={{ marginTop: 40 }}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
                if (event.key === "Enter") {
                  setLoadingBtn(true);
                  ref.current.submit();
                }
              }}
            />
          </Form.Item>
        </Form>
        <p style={{ color: "darkred", textAlign: "center", fontWeight: 600 }}>
          {errorText}
        </p>
      </Modal>
    </div>
  );
};

export default SignIn;
